// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3G8ey","choiceBoxes":"toolbarselects_choiceBoxes__3FkIG","simpleField":"toolbarselects_simpleField__2VQ_X"};